import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useModal, useStore, useToast, usePopup, usePage } from "@/comn/hooks"; // hook
import {
    BASE,
    URLS,
    APIS,
    SF_CSTM_OFCR_CHG_HIST_SRCH,
    SG_CSTM_OFCR_CHG_HIST_LIST,
    SG_CSTM_OFCR_CHG_HIST_EXCEL_LIST,
} from "@/tra/tancis/ptli/usr/ofcrhist/service/PtliCstmOfcrChgHistService";
import dayjs from "dayjs";

/*
 * Customs employee change history list
 * !== 세관직원변경이력 ==!
 */
export const PTLI0904001Q = (): JSX.Element => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "cstmCd" },
            { area: "comnCd", comnCd: "PTL0003" },
            { area: "comnCd", comnCd: "PTL0001" },
            { area: "cstmOrgzCd" },
        ],
    });
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const [load, setLoad] = useState(false);

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Search customs employee change history !== 세관직원변경이력 검색 ==!
        cstmOfcrChgHistSrch: useForm({
            defaultSchema: SF_CSTM_OFCR_CHG_HIST_SRCH,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Customs employee change history list !== 세관직원변경이력 목록 ==!
        cstmOfcrChgHistList: useGrid({
            defaultSchema: SG_CSTM_OFCR_CHG_HIST_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        cstmOfcrChgHistExcelList: useGrid({
            defaultSchema: SG_CSTM_OFCR_CHG_HIST_EXCEL_LIST,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Inquiry of Customs Employee Change History List !== 세관직원변경이력 목록 조회 ==!
        getCstmOfcrChgHistList: useFetch({
            api: (page = grid.cstmOfcrChgHistList.page) => {
                return APIS.getCstmOfcrChgHistList(
                    form.cstmOfcrChgHistSrch.getValues(),
                    page,
                    grid.cstmOfcrChgHistList.size,
                );
            },
            enabled: comnUtils.isEmpty(form.cstmOfcrChgHistSrch.errors) && form.cstmOfcrChgHistSrch.isSubmitted,
            key: [grid.cstmOfcrChgHistList.page, grid.cstmOfcrChgHistList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.cstmOfcrChgHistSrch.getValues(),
                    page: grid.cstmOfcrChgHistList.page,
                    size: grid.cstmOfcrChgHistList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
        // Get a excel list of Customs Officer. !== 세관직원 엑셀 목록을 조회한다. ==!
        getCstmOfcrChgHistExcelList: useFetch({
            api: (data: any) => (load ? APIS.getCstmOfcrChgHistExcelList(data) : null),
            enabled: comnUtils.isEmpty(form.cstmOfcrChgHistSrch.errors),
            onSuccess: () => {
                if (load) {
                    grid.cstmOfcrChgHistExcelList.exportExcel({
                        // Internal Portal Customs User Information !== 내부 포털_세관_사용자 정보 ==!
                        excelName: `${t("L_INT_PTL")}_Internal User Change History_${t("T_USR_INFO")}_${dayjs().format(
                            "DD/MM/YYYY HHmm",
                        )}`,
                        sheetName: "Sheet1",
                    });
                }
                setLoad(false);
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Inquiry of Customs Employee Change History List !== 세관직원변경이력 목록 조회 ==!
        getCstmOfcrChgHistList: () => {
            form.cstmOfcrChgHistSrch.handleSubmit(
                (data) => {
                    grid.cstmOfcrChgHistList.setPage(0);
                    fetch.getCstmOfcrChgHistList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
    };

    const render = {
        cell: {
            usrNm: (props: any) => {
                const { rowValues, value } = props;
                return <Link to={`${URLS.ptli0904002q}/${rowValues.usrDmnId}`}>{value}</Link>;
            },
        },
    };

    //usrHistCnt

    useEffect(() => {
        handler.getCstmOfcrChgHistList();
    }, []);

    useEffect(() => {
        const store = getStore(pgeUid);
        if (!comnUtils.isEmpty(store) || load) {
            fetch.getCstmOfcrChgHistExcelList.fetch(store.form);
        }
    }, [load]);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.cstmOfcrChgHistSrch.schema.usrNm}></Group.Control>
                                <Group.Control {...form.cstmOfcrChgHistSrch.schema.usrDmnId}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.cstmOfcrChgHistSrch.schema.cstmOfcrNo}></Group.Control>
                                <Group.Control
                                    {...form.cstmOfcrChgHistSrch.schema.usrStatCd}
                                    all={true}
                                ></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control
                                    {...form.cstmOfcrChgHistSrch.schema.cstmSctnCd}
                                    popupParams={{ cstmOrgzTpCd: "S" }}
                                />
                                <Group.Control {...form.cstmOfcrChgHistSrch.schema.cstmOfceCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control
                                    {...form.cstmOfcrChgHistSrch.schema.cstmUnitCd}
                                    popupParams={{ cstmOrgzTpCd: "U" }}
                                />
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role={"reset"}
                                    onClick={() => {
                                        form.cstmOfcrChgHistSrch.reset();
                                    }}
                                >
                                    {t("B_RESET")}
                                </Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role={"search"}
                                    onClick={() => {
                                        handler.getCstmOfcrChgHistList();
                                    }}
                                >
                                    {t("B_SRCH")}
                                </Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    {<Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={() => {
                                    setLoad(true);
                                }}
                            ></Button>
                        </Layout.Left>
                    </Layout>}
                    <Group.Section>
                        <Grid
                            {...grid.cstmOfcrChgHistList.grid}
                            data={fetch.getCstmOfcrChgHistList.data?.usrHistList}
                            render={render}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Group hidden>
                <Grid
                    {...grid.cstmOfcrChgHistExcelList.grid}
                    data={fetch.getCstmOfcrChgHistExcelList.data?.usrHistExcelList}
                />
            </Group>
        </Page>
    );
};
